import { InjectionToken } from "@angular/core";

export const TIMEZONE = new InjectionToken<string>("Timezone used for datetime module things");
